import React from 'react'
import FormFieldError from './FormFieldError.jsx'

function InputGroup({
  compact,
  handleInputChange,
  formValidation,
  formData,
  fieldName,
  fieldId,
  placeholder,
  label,
  list,
  type = 'text',
  disabled = false,
  defaultValue,
  onKeyUp = null,
  disableAutoComplete = false,
}) {
  const formValidationError =
    formValidation &&
    formValidation[fieldName] &&
    formValidation[fieldName].error

  const attributes = {
    defaultValue: formData ? formData[fieldName] || '' : defaultValue || '',
    type: type,
    disabled: disabled,
    list: list,
    id: fieldId,
    'data-field-name': fieldId,
    name: fieldName,
    placeholder: placeholder,
    onChange: handleInputChange,
    onKeyUp: onKeyUp,
  }

  if (disableAutoComplete) {
    attributes.autoComplete = 'off'
  }

  attributes.className = compact
    ? `Input Input--floatingLabel ${formValidationError ? 'Input--error' : ''}`
    : `Input ${formValidationError ? 'Input--error' : ''}`

  const renderInput = () => {
    return <input {...attributes} />
  }

  const renderLabel = () => {
    return (
      <label htmlFor={fieldId} className="Input-label">
        {label}
      </label>
    )
  }

  return (
    <div
      className={`Input-group ${
        compact ? 'u-marginBottom3gu' : 'u-marginBottom2gu'
      }`}
      role="group"
      aria-labelledby="Login Form"
    >
      {compact ? (
        <>
          {renderInput()}
          {renderLabel()}
        </>
      ) : (
        <>
          {renderLabel()}
          {renderInput()}
        </>
      )}
      <FormFieldError formValidation={formValidation} fieldName={fieldName} />
    </div>
  )
}

export default InputGroup
